export enum StepperEvents {
    ActivateStep = 'ActivateStep',
}
